import './checkbox-group.scss'

export default (props) => {
    const {
        error,
        displayError,
        message,
        helpertext,
        label,
        options,
        ...inputProps // TODO: Remove style and classname??
    } = props
    
    return (
        <fieldset className={`input-checkbox-group `} style={props.style}>
            <legend className="label">
                {label}
            </legend>
            <span id={`${props.id || props.name}_help`} className="helpertext">
                {helpertext}
            </span>
            <div className={`${props.className || ''}`}>

        
            {props.options && props.options.map((option, i) =>
                <label
                    key={`${props.name || props.id}_${option.value}`}
                    htmlFor={`${props.id || props.name}.${option.value}`}
                    className="input input-checkbox"
                >
                    <span className="group">
                        <input
                            id={`${props.id || props.name}.${option.value}`}
                            type="checkbox"
                            {...inputProps}
                            name={props.value}
                            value={option.value}
                        />
                        <span className="svg-checkbox">
                            <svg className="svg" width="24" height="24" viewBox="0 0 24 24">
                                <g
                                    fill="none"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                >
                                    <rect className="fill" height="20" rx="2" width="20" x="2" y="2"></rect>
                                    <polyline
                                        className="stroke checkbox-checked"
                                        points="7 13 10 16 17 8"
                                    ></polyline>
                                </g>
                            </svg>
                        </span>
                        <span className="label-inline">{option.label}</span>
                    </span>
                </label>
            )}
            
             </div>
            {displayError && error ?
                <span className='input error'><p id={`${props.id || props.name}_error`} className="message error">
                    <span
                        className="icon xsmall"
                        style={{
                            WebkitMaskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled-filled.svg)",
                            maskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled-filled.svg)",
                            color: "currentColor"
                        }}>
                    </span>
                    {error}
                </p>
                </span>
                :
                <span className='input'>
                    <p id={`${props.id || props.name}_message`} className="message">
                        {message}
                    </p>
                </span>
            }
        </fieldset>
    )
};